import { useEffect, useCallback } from 'react';
import { useSettings } from '../context/SettingsContext';

/**
 * Hook to load and execute Google reCAPTCHA v3.
 * Loads the script once globally when a site key is configured in admin settings.
 */
export const useRecaptcha = () => {
  const { settings } = useSettings();
  const siteKey = settings.recaptcha_site_key;

  useEffect(() => {
    if (!siteKey) return;
    if (document.querySelector(`script[src*="recaptcha/api.js"]`)) return;
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    document.head.appendChild(script);
  }, [siteKey]);

  const execute = useCallback(async (action) => {
    if (!siteKey || !window.grecaptcha) return '';
    try {
      return await window.grecaptcha.execute(siteKey, { action });
    } catch {
      return '';
    }
  }, [siteKey]);

  return { execute, enabled: !!siteKey };
};
